import { useMemo } from 'react'

import Box from '@mui/material/Box'
import { COLLAPSE_ANIMATION } from '@/constants/navigationDrawer'
import { menu } from '@/router/routes'
import { useAuthStore } from '@/stores/useAuthStore'
import { useUiStore } from '@/stores/useUiStore'

import { NAV_MENU_TEST_IDS } from './constants'
import { NavMenuItem } from './NavMenuItem'
import { ListContainer } from './NavMenuListContainer'

export const NavMenuContent = () => {
  const isNavExpanded = useUiStore((s) => s.isDesktopNavExpanded)
  const platform = useAuthStore((s) => s.platform)

  const items = useMemo(() => {
    return menu.filter((item) => item?.platforms?.includes(platform) || false)
  }, [platform])

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <ListContainer
        data-testid={NAV_MENU_TEST_IDS.NAV_MENU_CONTENT}
        sx={{
          transition: COLLAPSE_ANIMATION,
          maxWidth: isNavExpanded ? '100%' : 36,
          marginLeft: isNavExpanded ? 0 : 0.95,
          pointerEvents: 'none',
          '& .MuiListItemButton-root': {
            transition: COLLAPSE_ANIMATION,
            marginTop: isNavExpanded ? 0 : 0.5,
            marginBottom: isNavExpanded ? 0 : 0.5,
            height: isNavExpanded ? 45 : 36,
            borderRadius: isNavExpanded ? 0 : 2.5,
            '.MuiListItemIcon-root': {
              transition: COLLAPSE_ANIMATION,
              marginLeft: isNavExpanded ? 0 : -0.975
            }
          }
        }}
      >
        {items.map((item) => (
          <NavMenuItem key={item.label} item={item} />
        ))}
      </ListContainer>
    </Box>
  )
}
